import { ModuleLayout } from "layouts";
import AllCustomers from "./AllCustomers";

function Customers() {
  return (
    <ModuleLayout title="All Customers">
      <AllCustomers />
    </ModuleLayout>
  );
}
export default Customers;
